import { doGETRequest, doPOSTRequest, doPUTRequest } from "./Api";

class BuyerPricesApi {
  private static basePath = "/product-prices-for-buyers";

  public static async update(data: any) {
    return doPUTRequest(this.basePath, data);
  }

  public static async filterPrices(params: any) {
      const query = new URLSearchParams(params).toString();
      return doGETRequest(`${this.basePath}?${query}`);
  }

}

export default BuyerPricesApi;
